import Angle from "../../../../../../../src/entities/Angle/Angle";
import Line from "../../../../../../../src/entities/Line/Line";
import RedPoint from "../../../../../../../src/entities/RedPoint";
import { Coord } from "../../../../../../../src/types/Interface";
import DrawLineAnimation from "../../../animations/Supplementary/DrawLineAnimation";
import MoveAngleAnimation from "../../../animations/Supplementary/MoveAngleAnimation";
import PointAnimation from "../../../animations/Supplementary/PointAnimation";
import RotateAngleAnimation from "../../../animations/Supplementary/RotateAngleAnimation";



export function PointAnim(pointArr: RedPoint[], visible: boolean): Promise<void> {
  return new Promise((resolve) => {
    pointArr.forEach((point: RedPoint) => {
      point.visible = true;
      point.scale = 0.2;
      new PointAnimation(point, visible, () => resolve());
    })
  })
}

export function DrawLinesAnim(guideLines: Line[], lC: Coord[][], isReverse:boolean): Promise<void> {
  return new Promise((resolve) => {
    guideLines.forEach((guideLine, gI) => {
      const pCoord = lC[gI][0];
      const sCoord = isReverse ? lC[gI][1] : lC[gI][0];
      const tCoord = isReverse ? lC[gI][0] : lC[gI][1]
      new DrawLineAnimation(guideLine, pCoord, sCoord, tCoord, () => resolve());
    });
  })
}

export function MoveAngles(angles: Angle[], points: Coord[]): Promise<void> {
  return new Promise((resolve) => {
    angles.forEach((angle, aI) => {
      new MoveAngleAnimation(angle, points[aI], () => resolve());
    })
  })
}

export function RotateAngle(angles: Angle[], rotations: number[]): Promise<void> {
  return new Promise((resolve) => {
    angles.forEach((angle, aI) => {
      new RotateAngleAnimation(angle, rotations[aI], 300, () => resolve())
    })
  })
}